/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Linkeduser1Inputs */

const de__field_linkeduser1 = /** @type {(inputs: _Field_Linkeduser1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHANCENraum Nutzer`)
};

/**

* @param {_Field_Linkeduser1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_linkeduser1 = /** @type {((inputs?: _Field_Linkeduser1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Linkeduser1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_linkeduser1(inputs)
});
export { _field_linkeduser1 as "_field_linkedUser" }